const autoCalculateDropdownBackdropHeight = () => {
    if(document.querySelector('.stoof-menu-cat-children--holder_active')){
        const inner = document.querySelector('.stoof-menu-cat-children--holder_active');
        const heightInner = inner.offsetHeight;
        const target = inner.closest('.dropdown-menu');
        if(target !== null){
            target.style.height =  heightInner+'px';
        }

    }
}
export default autoCalculateDropdownBackdropHeight;